import { useState } from 'react'
import axios from 'axios'
import { cleanAlpha, cleanPhone } from '../../modules/Functions'

export const useFormDistribuidor = (
  initialForm,
  validateForm
) => {
  const [form, setForm] = useState(initialForm)
  const [errors, setErrors] = useState({})
  const [col, setCol] = useState(null)
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(null)
  // const [selectedOption, setSelectedOption] = useState(null)

  const handleChange = async (event) => {
    const { name, value, type } = event.target

    if (name === 'pais') {
      form.cp = ''
      form.estado = ''
      form.ciudad = ''
      form.colonia = ''
      setCol([])
      setForm(form)
    }

    if (form.pais === 'Mexico') {
      if (name === 'cp') {
        const regex = /^\d*$/

        if (!regex.test(value)) {
          form.cp = ''
          form.estado = ''
          form.ciudad = ''
          form.colonia = ''
          setCol(null)
          setForm(form)
        } else {
          const regexCP = /^\d{5}$/
          if (value.length === 5) {
            if (regexCP.test(value)) {
              axios
                .post(
                  process.env.REACT_APP_BACKEND_URL + 'Colonias/', {
                    cp: value
                  }
                )
                .then(function (response) {
                  const dir = response.data
                  if (dir.status) {
                    const { data } = dir

                    form.cp = data.cp.toString()
                    form.estado = data.estado.toString()
                    form.ciudad = data.ciudad.toString()
                    form.colonia = ''
                    setCol(data.colonias)
                    setForm(form)
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            }
          } else {
            setTimeout(() => {
              form.cp = value
              form.estado = ''
              form.ciudad = ''
              form.colonia = ''
              setCol(null)
              setForm(form)
            }, 0)
          }
        }
      }
    }
    // Manejo especial para checkboxes (array de valores)
    if (type === 'checkbox-group') {
      setForm((prev) => ({
        ...prev,
        [name]: value // 'value' es un array con los valores seleccionados
      }))
    } else {
      // Para inputs normales
      setForm((prev) => ({
        ...prev,
        [name]: value
      }))
    }
  }

  const handleInput = async (event) => {
    const { name, value } = event.target

    let v
    if (
      name === 'nombre' ||
            name === 'cargo' ||
            name === 'otrosProductos'
    ) {
      v = cleanAlpha(value)
    }

    if (name === 'telefono') {
      v = cleanPhone(value)
    }

    if (event.target.value !== v) event.target.value = v
  }

  const captchaChange = (event) => {
    if (event) {
      setTimeout(() => {
        form.captcha = true
        setForm(form)
      }, 0)
    } else {
      setTimeout(() => {
        form.captcha = false
        setForm(form)
      }, 0)
    }
  }
  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)

    const err = await validateForm(form)

    console.log(err)

    if (err === null) {
      axios
        .post(
          process.env.REACT_APP_BACKEND_URL + 'potential-distributor', form, {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then(function (response) {
          setResponse(response.data)
        })
        .catch(function (error) {
          setResponse(error.response.data)
        })
    } else {
      setErrors(err)
      setLoading(false)
      setTimeout(() => setErrors({}), 10000)
    }
  }

  return {
    form,
    errors,
    loading,
    col,
    response,
    captchaChange,
    handleChange,
    handleInput,
    handleSubmit
  }
}
